import { useState } from 'react';

/* eslint-disable-next-line */
export interface PreviewCardProps {
  payload: {
    image: string;
    title: string;
    views: number;
  };
  handlers: {
    onCourseClick: React.MouseEventHandler<HTMLImageElement>;
  };
}

interface IconProps {
  onClick: React.MouseEventHandler<HTMLDivElement>;
}
const LoveIcon = ({ onClick }: IconProps) => (
  <div
    className="rounded-md  bg-white h-8 w-8 flex justify-center items-center  mx-1 hover:bg-gray-200 "
    onClick={onClick}
  >
    <svg
      className="h-4 w-4 fill-current text-gray-400"
      viewBox="0 0 485 485"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M343.611,22.543c-22.614,0-44.227,5.184-64.238,15.409c-13.622,6.959-26.135,16.205-36.873,27.175
  c-10.738-10.97-23.251-20.216-36.873-27.175c-20.012-10.225-41.625-15.409-64.239-15.409C63.427,22.543,0,85.97,0,163.932
  c0,55.219,29.163,113.866,86.678,174.314c48.022,50.471,106.816,92.543,147.681,118.95l8.141,5.261l8.141-5.261
  c40.865-26.406,99.659-68.479,147.681-118.95C455.837,277.798,485,219.151,485,163.932C485,85.97,421.573,22.543,343.611,22.543z"
      />
    </svg>
  </div>
);

const FolderIcon = ({ onClick }: IconProps) => (
  <div
    className="rounded-md bg-white h-8 w-8 flex justify-center items-center  mx-1  hover:bg-gray-200"
    onClick={onClick}
  >
    <svg
      className="h-4 w-4 fill-current text-gray-400"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="m15 2h-6c-.312988 0-.612305-.149414-.799805-.399902l-.600586-.800293c-.375488-.500977-.973633-.799805-1.59961-.799805h-5c-.552246 0-1 .447754-1 1v12c0 .552246.447754 1 1 1h14c.552246 0 1-.447754 1-1v-10c0-.552246-.447754-1-1-1zm-2 7h-2v2h-2v-2h-2v-2h2v-2h2v2h2z"
        transform="translate(0 1)"
      />
    </svg>
  </div>
);

const ViewIcon = () => (
  <svg
    className="h-4 w-4 fill-current text-gray-500 m-1"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M10.394 2.08a1 1 0 00-.788 0l-7 3a1 1 0 000 1.84L5.25 8.051a.999.999 0 01.356-.257l4-1.714a1 1 0 11.788 1.838L7.667 9.088l1.94.831a1 1 0 00.787 0l7-3a1 1 0 000-1.838l-7-3zM3.31 9.397L5 10.12v4.102a8.969 8.969 0 00-1.05-.174 1 1 0 01-.89-.89 11.115 11.115 0 01.25-3.762zM9.3 16.573A9.026 9.026 0 007 14.935v-3.957l1.818.78a3 3 0 002.364 0l5.508-2.361a11.026 11.026 0 01.25 3.762 1 1 0 01-.89.89 8.968 8.968 0 00-5.35 2.524 1 1 0 01-1.4 0zM6 18a1 1 0 001-1v-2.065a8.935 8.935 0 00-2-.712V17a1 1 0 001 1z" />
  </svg>
);
export function PreviewCard(props: PreviewCardProps) {
  const [isShown, setIsShown] = useState(false);
  const { onCourseClick } = props.handlers;
  const { payload } = props;
  return (
    <div
      className="relative cursor-pointer"
      onMouseEnter={() => setIsShown(true)}
      onMouseLeave={() => setIsShown(false)}
    >
      <div
        className="bg-gradient-to-t from-black to-gray-300 rounded-lg shadow-md"

        // onClick={handlers.onAdd}
      >
        <img
          onClick={onCourseClick}
          className={`bg-blue-50 h-72 object-fill w-full rounded-lg ${
            isShown ? 'opacity-25' : ''
          } transition  duration-200 ease-in-out hover:opacity-25 `}
          alt="card"
          src={payload.image}
        ></img>
      </div>

      {isShown && (
        <div
          className=" block w-full absolute z-1 bottom-16  left-2 m-2  "
          role="dialog"
          aria-modal="true"
        >
          <p className="w-6/12 text-xl capitalize  text-white font-semibold">
            {payload.title}
          </p>
        </div>
      )}
      {isShown && (
        <div
          className=" block   transform ease-in-out        absolute  bottom-16  right-2 m-2 "
          role="dialog"
          aria-modal="true"
        >
          {/* <div className=" flex flex-row z-50  justify-between ">
            <FolderIcon />
            <LoveIcon />
          </div> */}
        </div>
      )}
      <div className="px-3 py-4 flex justify-between">
        <div className="  w-10/12 flex flex-row  justify-arrond ">
          <p className="  text-base  truncate   font-semibold  overflow-auto capitalize ">
            {payload.title}
          </p>
          {/* <div className=" pl-3 ">
              <FieldBadge field={payload.school} />
            </div> */}
        </div>
        <div className="flex flex-row ">
          <ViewIcon /> {payload.views}
        </div>
      </div>
    </div>
  );
}

export default PreviewCard;
